import React, { useCallback, useMemo } from "react";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import type {
  ProductListProperty,
  ProductListViewItem,
} from "components/_ProductConfigurator/store/ProductConfiguration.types";
import { ValidationResult } from "components/_ProductConfigurator/store/ProductConfiguration.types";
import cx from "classnames";
import { UncontrolledTooltip } from "reactstrap";

type ProductSuggestionTableRowProps = ProductListViewItem & {
  currentRowKey: number;
};

export const ProductSuggestionTableRow = ({
  ordercodeState,
  properties,
  columnTitles,
  currentRowKey,
  selectedAccessories,
}: ProductSuggestionTableRowProps) => {
  const { changeProductToSuggested } =
    useProductConfiguratorStore.use.actions();

  const handleProductSelection = useCallback(() => {
    changeProductToSuggested({
      suggestedProductOrderCode: ordercodeState,
      selectedAccessories,
    });
  }, [changeProductToSuggested, ordercodeState, selectedAccessories]);

  const sortedProperties = useMemo(() => {
    const map = new Map(properties.map((cell) => [cell.propertyId, cell]));

    return columnTitles
      .map((col) => map.get(col.key))
      .filter((prop): prop is ProductListProperty => !!prop);
  }, [columnTitles, properties]);

  return (
    <tr onClick={handleProductSelection}>
      {sortedProperties?.map((property, key) => (
        <td key={key} id={`resultinglistTableCell-${currentRowKey}-${key}`}>
          <div
            className={cx("d-flex", {
              "justify-content-between fw-bold":
                property?.validationResult !== ValidationResult.None,
              "justify-content-center":
                property?.validationResult === ValidationResult.None,
            })}
          >
            {property?.validationResult === ValidationResult.Critical && (
              <div className="text-danger">X</div>
            )}
            {property.value}
          </div>
          {property.validationMessage && (
            <UncontrolledTooltip
              target={`resultinglistTableCell-${currentRowKey}-${key}`}
            >
              {property.validationMessage}
            </UncontrolledTooltip>
          )}
        </td>
      ))}
    </tr>
  );
};
